/**
 * @generated SignedSource<<c75e4b69a8ade81d8e667ac66ad93b39>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useMCPEnabled_query$data = {
  readonly UrlConfig: {
    readonly mcp: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useMCPEnabled_query";
};
export type useMCPEnabled_query$key = {
  readonly " $data"?: useMCPEnabled_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useMCPEnabled_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useMCPEnabled_query",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UrlConfig",
          "kind": "LinkedField",
          "name": "UrlConfig",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mcp",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "8e78e895f8c2c2df4fae546d99d51053";

export default node;
